<!--
    Summary:
        firstchoice.exhibition.web - mthfr-p9
        Pathway for Folic Acid Supplementation
    ChangeLog:
        wangn on 2020/12/6 added
-->
<template>
  <div class="v-mthfr-p9" title="mthfr-p9">
    <img-card class="card">
      <div slot="title" style="width:100%;">{{$t('Mthfr.P9_Title')}}</div>
      <!-- <p class="p9-content">{{$t('Mthfr.P9_Content')}}</p> -->
      <!-- <div class="content">
        <div class="category">
          <div class="good box">
            <div class="box-title">{{$t('Mthfr.P9_Title2')}}</div>
            <div>{{$t('Mthfr.P9_1_1')}}</div>
            <div>{{$t('Mthfr.P9_1_2')}}</div>
            <div>{{$t('Mthfr.P9_1_3')}}</div>
          </div>
          <div class="category-title">
            <div>{{$t('Mthfr.P9_1_Title')}}</div>
            <div>{{$t('Mthfr.P9_1_Title2')}}</div>
          </div>
          <div class="bad box">
            <div class="box-title">{{$t('Mthfr.P9_Title3')}}</div>
            <div>{{$t('Mthfr.P9_1_4')}}</div>
            <div>{{$t('Mthfr.P9_1_5')}}</div>
            <div>{{$t('Mthfr.P9_1_6')}}</div>
          </div>
        </div>
        <div class="category">
          <div class="good box">
            <div>{{$t('Mthfr.P9_2_1')}}</div>
            <div>{{$t('Mthfr.P9_2_2')}}</div>
            <div>{{$t('Mthfr.P9_2_3')}}</div>
          </div>
          <div class="category-title">
            <div>{{$t('Mthfr.P9_2_Title')}}</div>
            <div>{{$t('Mthfr.P9_2_Title2')}}</div>
          </div>
          <div class="bad box">
            <div>{{$t('Mthfr.P9_2_4')}}</div>
            <div>{{$t('Mthfr.P9_2_5')}}</div>
            <div>{{$t('Mthfr.P9_2_6')}}</div>
          </div>
        </div>
        <div class="category">
          <div class="good box">
            <div>{{$t('Mthfr.P9_3_1')}}</div>
            <div>{{$t('Mthfr.P9_3_2')}}</div>
            <div>{{$t('Mthfr.P9_3_3')}}</div>
          </div>
          <div class="category-title">
            <div>{{$t('Mthfr.P9_3_Title')}}</div>
            <div>{{$t('Mthfr.P9_3_Title2')}}</div>
          </div>
          <div class="bad box">
            <div>{{$t('Mthfr.P9_3_4')}}</div>
            <div>{{$t('Mthfr.P9_3_5')}}</div>
          </div>
        </div>
      </div> -->
      <div style="width: 100%;display: flex;justify-content: center;align-items: center;">
      <div class="boxs" v-if="$i18n.locale=='zh-TCC'" style="width:80%">
          <img src="../../../assets/images/mthfr/fcway_zh.png" style="width:100%;height:100%">
        </div>
        <div class="boxs" v-if="$i18n.locale=='zh-CN'">
          <img src="../../../assets/images/mthfr/fcway_cn.png" style="width:100%;height:100%">
        </div>
        <div class="boxs" v-if="$i18n.locale=='en-US'">
          <img src="../../../assets/images/mthfr/fcway_en.png" style="width:100%;height:100%">
        </div>
      </div>
    </img-card>
  </div>
</template>

<script>
  import ImgCard from "../img-card";

  export default {
    name: "mthfr-p9",
    components: {ImgCard}
  }
</script>
<style lang="scss">
  .en{
    .v-mthfr-p9{
      p.p9-content{
        display: block;
      }

      .content{
        .category{
          .box{
            width: 600px;
          }
        }
      }
      
    .boxs {
       
        display: flex;

        img {
          width: 100%;
          height: 100%;
        }
    }
    }
  }
</style>
<style lang="scss">
  .v-mthfr-p9 {
    background-color: rgba(251, 207, 192, 0.2);
    font-size: 13px;

    p.p9-content{
      display: none;
      padding-bottom: 20px;
    }
    .content {
      display: flex;
      flex-direction: column;
      align-items: center;

      .category {
        display: flex;

        .box{
          position: relative;
          text-align: left;
          width: 400px;
          padding: 30px;
          display: flex;
          flex-flow: column;
          justify-content: center;
          &:after{
            position: absolute;
            content: ' ';
            width: 100%;
            height: 2px;
            background: #c03239;
            bottom: 0;
            left: -53px;
          }
          .box-title {
            margin-top: -20px;
            font-size: 18px;
            color: #5bcfde;
            margin-bottom: 12px;
          }
        }

        .good {
          text-align: right;
          &:after{
            background: #5bcfde;
            left: auto;
            right: -53px;
          }
        }

        .category-title {
          width: 106px;
          background: #edb2c4;
          color: #fff;
          display: flex;
          flex-flow: column;
          align-items: center;
          justify-content: center;
        }
      }
    }
  }
</style>




// WEBPACK FOOTER //
// src/view/genedetection/mthfr/mthfr-p9.vue